var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "searchAndResultsPage" },
    [
      _c("div", { staticClass: "mainCont" }, [
        _c("div", { staticClass: "searchRequirement" }, [
          _c("div", { staticClass: "select" }, [
            _c(
              "div",
              { staticClass: "track disFlex" },
              [
                _c("el-input", {
                  staticClass: "trackArea",
                  attrs: {
                    type: "textarea",
                    rows: "10",
                    resize: "none",
                    placeholder: _vm.$t("spww.placeholder"),
                  },
                  model: {
                    value: _vm.trackData,
                    callback: function ($$v) {
                      _vm.trackData = $$v
                    },
                    expression: "trackData",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn ubiTrackBox",
                    on: {
                      mouseenter: function ($event) {
                        _vm.searchBtnHover = true
                      },
                      mouseleave: function ($event) {
                        _vm.searchBtnHover = false
                      },
                      click: _vm.truckingNoTrack,
                    },
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.searchBtnHover,
                          expression: "!searchBtnHover",
                        },
                      ],
                      attrs: { src: _vm.options.btnBgi, alt: "" },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.searchBtnHover,
                          expression: "searchBtnHover",
                        },
                      ],
                      attrs: { src: _vm.options.btnBgiHover, alt: "" },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "contactUs" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.options.contactUs) + "\n        "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "searchResult" },
          _vm._l(_vm.resTrackData, function (item, index) {
            return _c("div", { key: index, staticClass: "item" }, [
              !item.notExist
                ? _c(
                    "div",
                    {
                      ref: _vm.getOrderItemRef(index),
                      refInFor: true,
                      staticClass: "order-item",
                    },
                    [
                      _c("div", { staticClass: "order-txt" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "track_up_down_box",
                            on: {
                              click: function ($event) {
                                return _vm.changeDetails(item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("common.details"))),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "track_up_down",
                              attrs: {
                                src: item.deailFlag
                                  ? _vm.detials_arrow_up_img
                                  : _vm.detials_arrow_down_img,
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-hd" }, [
                        _c(
                          "div",
                          { staticClass: "state-rcol" },
                          _vm._l(_vm.nodes, function (cell, idx) {
                            return _c(
                              "div",
                              { key: cell.id, staticClass: "order-proces" },
                              [
                                idx !== 0
                                  ? _c("div", { staticClass: "proceArrow" }, [
                                      _c("img", {
                                        staticClass: "track_arrow",
                                        attrs: {
                                          src: _vm.handelProcess(
                                            cell.id,
                                            item.headerLight
                                          ),
                                          alt: "",
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "node ready",
                                    class: { bigWidth: cell.id === "SCN" },
                                  },
                                  [
                                    _c("div", { staticClass: "topIcon" }, [
                                      _c("img", {
                                        staticClass: "nodeIcon",
                                        staticStyle: {
                                          width: "43px",
                                          height: "43px",
                                        },
                                        attrs: {
                                          src: _vm.handelNode(
                                            cell.id,
                                            item.headerLight
                                          ),
                                          alt: "",
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "bodyPart",
                                        class: {
                                          hasLight:
                                            item.headerLight[cell.id].curLight,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "title" }, [
                                          _vm._v(_vm._s(cell.title)),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "time" }, [
                                          _vm._v(
                                            _vm._s(
                                              item.headerLight[cell.id]
                                                .timestamp
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.deailFlag,
                              expression: "item.deailFlag",
                            },
                          ],
                          staticClass: "order-bd",
                        },
                        [
                          _c("div", { staticClass: "event-list" }, [
                            _c(
                              "ul",
                              { ref: _vm.getUlRef(index), refInFor: true },
                              _vm._l(
                                item.trackDetails,
                                function (evtItem, evtIndex) {
                                  return _c(
                                    "li",
                                    {
                                      key: evtIndex,
                                      class: { first: evtIndex === 0 },
                                    },
                                    [
                                      _c("i", { staticClass: "node-icon" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "date" }, [
                                        _vm._v(_vm._s(evtItem.date)),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "txt" }, [
                                        _c(
                                          "span",
                                          { staticClass: "location" },
                                          [_vm._v(_vm._s(evtItem.location))]
                                        ),
                                        _vm._v(" "),
                                        !evtItem.showA
                                          ? _c(
                                              "span",
                                              { staticClass: "activity" },
                                              [_vm._v(_vm._s(evtItem.activity))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        evtItem.showA
                                          ? _c(
                                              "span",
                                              { staticClass: "activity" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: evtItem.url,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(evtItem.activity)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          item.webSiteInfo.length > 0
                            ? _c(
                                "div",
                                { staticClass: "forFurtherInformation" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("spww.forFurtherInformation")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "websites" },
                                    _vm._l(
                                      item.webSiteInfo,
                                      function (siteItem, siteIndex) {
                                        return _c(
                                          "div",
                                          {
                                            key: siteIndex,
                                            staticClass: "site",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "left description",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      siteItem.description
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "right",
                                                attrs: {
                                                  href: siteItem.webSite,
                                                  target: "_blank",
                                                },
                                              },
                                              [_vm._v(_vm._s(siteItem.webSite))]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order-btn" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onCopy($event, item, index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("common.copy")) + " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onTranslate(item, index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("common.translate")) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.notExist
                ? _c("div", { staticClass: "noRes" }, [
                    _c("span", { staticClass: "weight" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("spww.noEventFound")))]),
                  ])
                : _vm._e(),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("CopyDialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCopyDialog,
            expression: "showCopyDialog",
          },
        ],
        ref: "copyDialog",
        attrs: { "copy-tips": _vm.copyTips },
      }),
      _vm._v(" "),
      _c("TranslateDialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTranslateDialog,
            expression: "showTranslateDialog",
          },
        ],
        ref: "translateDialog",
        on: { changeLanTo: _vm.changeLanTo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }